import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetQuestionList, EResetQuestionListActionType } from './types';

export const resetQuestionList: () => TResetQuestionList = actionGenerator<EResetQuestionListActionType.Reset>(
  EResetQuestionListActionType.Reset,
);
